(() => {
  const MAX_SLIDES = 5;

  class ProductCardGallery {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector("[data-gallery-track]");
      this.slides = Array.from(root.querySelectorAll(".ProductCard__Slide"));
      this.prevButton = root.querySelector("[data-gallery-prev]");
      this.nextButton = root.querySelector("[data-gallery-next]");
      this.dots = Array.from(root.querySelectorAll("[data-gallery-dot]"));
      this.card = root.closest("product-card, .product-card, .ProductCard");
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchCurrentX = 0;
      this.isPointerDown = false;
      this.hoverTimeout = null;

      // Fallback-Limit auf 5 Slides (falls Liquid mehr rendert)
      if (this.slides.length > MAX_SLIDES) {
        this.slides.slice(MAX_SLIDES).forEach(slide => slide.remove());
        this.slides = this.slides.slice(0, MAX_SLIDES);
      }
      if (this.dots.length > MAX_SLIDES) {
        this.dots.slice(MAX_SLIDES).forEach(dot => dot.remove());
        this.dots = this.dots.slice(0, MAX_SLIDES);
      }

      this.imageCount = this.slides.length;

      if (!this.track || this.slides.length <= 1) return;

      this.bindEvents();
      this.update();
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.prev();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.next();
        });
      }

      this.dots.forEach((dot) => {
        dot.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.goTo(Number(dot.dataset.slideTo || 0));
        });
      });

      this.track.addEventListener("touchstart", this.onTouchStart.bind(this), { passive: true });
      this.track.addEventListener("touchmove", this.onTouchMove.bind(this), { passive: true });
      this.track.addEventListener("touchend", this.onTouchEnd.bind(this));

      this.track.addEventListener("pointerdown", this.onPointerDown.bind(this));
      this.track.addEventListener("pointerup", this.onPointerUp.bind(this));

      this.root.addEventListener("mouseenter", this.onMouseEnter.bind(this));
      this.root.addEventListener("mouseleave", this.onMouseLeave.bind(this));

      if (this.card) {
        this.card.addEventListener("click", (event) => {
          const trigger = event.target.closest("[data-variant-option]");
          if (!trigger) return;

          const mediaId = trigger.dataset.variantMedia;
          let targetIndex = 0;

          if (mediaId) {
            const foundIndex = this.slides.findIndex(
              (slide) => String(slide.dataset.mediaId) === String(mediaId)
            );

            if (foundIndex >= 0) {
              targetIndex = foundIndex;
            }
          }

          this.goTo(targetIndex);

          this.card.querySelectorAll("[data-variant-option]").forEach((el) => {
            const isActive = el === trigger;
            el.classList.toggle("is-active", isActive);
            el.setAttribute("aria-pressed", isActive ? "true" : "false");
            });
        });
      }
    }

    onTouchStart(event) {
      if (!event.touches || !event.touches.length) return;
      this.touchStartX = event.touches[0].clientX;
      this.touchCurrentX = this.touchStartX;
    }

    onTouchMove(event) {
      if (!event.touches || !event.touches.length) return;
      this.touchCurrentX = event.touches[0].clientX;
    }

    onTouchEnd() {
      const diff = this.touchCurrentX - this.touchStartX;
      if (Math.abs(diff) < 40) return;
      diff < 0 ? this.next() : this.prev();
    }

    onPointerDown(event) {
      this.isPointerDown = true;
      this.touchStartX = event.clientX;
      this.touchCurrentX = event.clientX;
    }

    onPointerUp(event) {
      if (!this.isPointerDown) return;
      this.isPointerDown = false;
      this.touchCurrentX = event.clientX;

      const diff = this.touchCurrentX - this.touchStartX;
      if (Math.abs(diff) < 50) return;
      diff < 0 ? this.next() : this.prev();
    }

    onMouseEnter() {
      if (window.matchMedia("(hover: hover)").matches && this.imageCount > 1) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        if (this.currentIndex === 0) this.goTo(1);
      }, 180);
    }
    }

    onMouseLeave() {
      clearTimeout(this.hoverTimeout);
      if (window.matchMedia("(hover: hover)").matches) {
        this.goTo(0);
      }
    }

    prev() {
      const nextIndex = this.currentIndex <= 0 ? this.imageCount - 1 : this.currentIndex - 1;
      this.goTo(nextIndex);
    }

    next() {
      const nextIndex = this.currentIndex >= this.imageCount - 1 ? 0 : this.currentIndex + 1;
      this.goTo(nextIndex);
    }

    goTo(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.imageCount - 1));
      this.update();
    }

    update() {
      this.slides.forEach((slide, index) => {
        slide.classList.toggle("is-active", index === this.currentIndex);
      });

      this.dots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === this.currentIndex);
      });
    }
  }

function initProductCardGalleries(scope = document) {
    scope.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
      if (gallery.dataset.galleryInitialized === "true") return;
      gallery.dataset.galleryInitialized = "true";
      new ProductCardGallery(gallery);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initProductCardGalleries();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initProductCardGalleries(event.target);
  });

  document.addEventListener("shopify:section:reorder", (event) => {
    initProductCardGalleries(event.target);
  });
})();
